import { render, staticRenderFns } from "./ActivityReview.vue?vue&type=template&id=3c6e0278&scoped=true"
import script from "./ActivityReview.vue?vue&type=script&lang=js"
export * from "./ActivityReview.vue?vue&type=script&lang=js"
import style0 from "./ActivityReview.vue?vue&type=style&index=0&id=3c6e0278&prod&lang=scss&scoped=true"
import style1 from "./ActivityReview.vue?vue&type=style&index=1&id=3c6e0278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6e0278",
  null
  
)

export default component.exports